import React, { useRef } from "react";
import { CheckoutBundlePopupContainer } from "./CheckoutBundlePopup.container";
import { WidePopup, BundleCheckout } from "@obby/components";
import * as settings from "~/settings";

export function CheckoutBundlePopupView(props) {
  const {
    user,
    bundle,
    ticketType,
    course,
    tutors,
    locations,
    actions
  } = CheckoutBundlePopupContainer.useContainer();

  const popupWrapperRef = useRef();

  function onStepChange() {
    popupWrapperRef.current.scrollTo({
      top: 0
    });
  }

  return (
    <WidePopup onClose={actions.onClose} wrapperRef={popupWrapperRef}>
      <BundleCheckout
        course={course}
        bundle={bundle}
        courseId={course._id}
        courseThumbnail={course.images[0]}
        courseTitle={course.title}
        discount={course.discount}
        locations={locations}
        isSendingMaterial={course.requiresSendingPhysicalMaterial}
        onClose={actions.onClose}
        onConfirmFreeBooking={actions.onConfirmFreeBooking}
        onGetPaymentIntent={actions.onGetPaymentIntent}
        onStepChange={onStepChange}
        onValidateDiscount={actions.onValidateDiscount}
        onLoadDates={actions.onLoadMoreDates}
        onLogin={actions.onCheckoutLogin}
        stripePublicKey={settings.stripe.publicKey}
        ticketType={ticketType}
        tutors={tutors}
        user={user}
        userInputs={course.userInputs}
      />
    </WidePopup>
  );
}
